import React from 'react';
import loader from '/assets/loader.gif';

function Loader({ className = "flex items-center justify-center min-h-screen" }) {
  return (
    <div className={className}>
      <img src={loader} className='h-48 w-48' alt='loader'/>
    </div>
  );
}

export default Loader;